export default __webpack_public_path__ + "static/media/chrome-gray.8bf7d8ef.svg";